import {QueryParameter} from "../../connectivity/query-parameter.interface";
import {OrderBy} from "./order-by.interface";
import {ArrayHelper} from "../../helpers/array.helper";
import {QueryRequestBody} from "../../connectivity/query-request-body.interface";

export class IssueQuery {

    private _queryParameters: QueryParameter<unknown>[] = [];

    private _ordersBy: OrderBy[] = [];

    private _limit: number | null = null;

    private _offset: number = 0;

    private _includes: string[] = [];

    public addQueryParameters(...queryParameters: QueryParameter<unknown>[]): IssueQuery {
        this._queryParameters = [...this._queryParameters, ...queryParameters];

        return this;
    }

    public addOrdersBy(...ordersBy: OrderBy[]): IssueQuery {
        this._ordersBy = [...this._ordersBy, ...ordersBy];

        return this;
    }

    public setLimit(limit: number): IssueQuery {
        if (limit < 1) {
            console.warn(`01H9GRJ4JBRB6XRSNN541E5WH7: Given limit is lower than 1. Didn't changed limit.`)
            return this;
        }
        this._limit = limit;

        return this;
    }

    public setOffset(offset: number): IssueQuery {
        if (offset < 0) {
            console.warn(`01H9GRGAN1JX55AFR19M9234ZF: Given offset is lower than zero. Didn't changed offset.`);
            return this;
        }
        this._offset = offset;

        return this;
    }

    public addIncludes(...includes: string[]): IssueQuery {
        this._includes = [...this._includes, ...includes];

        return this;
    }

    public get requestBody(): QueryRequestBody<unknown> {
        return {
            queryParams: ArrayHelper.unique(this._queryParameters, item => item.key),
            orderBy: ArrayHelper.unique(this._ordersBy, item => item.key),
            limit: this._limit ?? -1,
            offset: this._offset,
            includes: ArrayHelper.unique(this._includes)
        }
    }

}